export default {
	cixiangweibitianxiang: 'この項目は必須です',
	dengluyihuode: 'よりシームレスなプロセスを得るためにログインします。',
	haimeiyouzhanghu: 'まだアカウントがありませんか？',
	lijizhuce: '今すぐ登録',
	xuanzebeishiwei: 'このオプションを選択すると、同意済みとみなされます',
	tiaokuan: '契約条件',
	yinsishengming: 'プライバシーに関する声明',
	yiji: 'および',
	huo: 'または',
	dianziyoujian: '電子メール',
	mima: 'パスワード',
	dengru: 'ログイン',
	qudenglu: 'ログインに移動',
	zhuce: '登録',
	zhucechenggong: '登録完了',
	buyizhi: '一致しない',
	meiyoushoudao: 'メール受信が確認されていませんか？',
	yikerenshenfen: 'ゲストとして続行',
	wangjimima: 'パスワードを忘れた',
	zhanghao: 'アカウント',
	yanzhengzhanghao: 'アカウントの確認',
	yanzhengmima: 'パスワードの確認',
	yanzhengdianziyoujian: '電子メールの確認',
	youketishi: 'ゲストとして続行すると、このウェブサイトの利用規約、データポリシー、およびクッキーポリシーに同意したことになります。',
	chakan: '表示',
	xuanzeriqi: '日付を選択',
	chufariqi: '出発日',
	huichengriqi: '帰国日',
	chongshe: 'リセット',
	queren: '確認',
	genggairiqi: '日付の変更',
	hangban: 'フライト',
	yingfuzonge: '合計金額',
	genggai: '変更',
	xianyoufujai: '既存のオプション',
	xinhangban: '新しいフライト',
	zhifu: '支払い',
	daojishi: '支払いカウントダウン',
	zuoweiyiyuding: '申し訳ありませんが、この座席は予約済みです。別の座席を選択してください',
	tianjiadaoyuding: '予約リストに追加',
	ewaituibukongjian: 'エクストラレッグルームシート、10行目のC席',
	xinyongka: 'クレジットカード',
	denglushiyongfacebook: 'Facebookでサインイン',
	jiazaizhong: 'ローディング中',
	denglushibai: 'ログイン失敗！',
	zhuceshibai: '登録失敗！',
	liru: '例',
	dengluchenggong: 'ログイン成功',
};
